// extracted by mini-css-extract-plugin
export default {"actions":"app-lists-FolderShareControls-FolderShareControls-module__mjd7Pf4tSZSzKjVTaFhz","avatars":"app-lists-FolderShareControls-FolderShareControls-module__Z0aPAIuOaiylFGiaUSrp"};